import React, { FC, useMemo } from 'react';

import { TableCell as BaseTableCell, Tooltip } from '@portal/common/components';
import { getValueKeys } from '@portal/common/models/data-key';
import { styled } from '@portal/common/theme';
import formatPdfValue from '@portal/common/utility/formatting/formatPdfValue';

import _ from '../../../locale/_';

const TableCell = styled(BaseTableCell)(({ theme }) => ({
    padding: '4px 0 4px 4px',
    fontSize: '1.3rem',
    [theme.breakpoint.md]: {
        padding: '4px 4px 4px 10px',
        fontSize: '1.55rem',
    },
}));

const ValueCell = styled(TableCell)(({ theme }) => ({
    textAlign: 'right',
    paddingRight: '20px',
    paddingLeft: 0,
}));

type Props = {
    value: string | number;
    filterKey: string;
    showDecimals: boolean;
    valueFields: string[];
};

const Cell: FC<Props> = ({ value, filterKey, showDecimals, valueFields }) => {
    const isValueCell = useMemo(
        () => [...valueFields, ...getValueKeys()].includes(filterKey) && value !== null,
        [filterKey, value, valueFields]
    );

    return isValueCell ? (
        <ValueCell key={filterKey}>
            <Tooltip key={filterKey} title={value} disableFocusListener>
                {formatPdfValue(value, showDecimals)}
            </Tooltip>
        </ValueCell>
    ) : (
        <TableCell key={filterKey}>{value}</TableCell>
    );
};

export default Cell;
